import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VidaAdapterLoginService } from './vida-adapter-login.service';

@Component({
  selector: 'vida-adapter-login',
  templateUrl: './vida-adapter-login.component.html',
  styleUrls: ['./vida-adapter-login.component.css']
})
export class VidaAdapterLoginComponent implements OnInit {
  loginForm: FormGroup;
  loginErrorMessage: string;
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private authservice: VidaAdapterLoginService
  ) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    if (this.authservice.isLoggednIn())
      this.router.navigateByUrl('/home');
  }
  get f() { return this.loginForm.controls; }

  authenticate() {
    this.loginErrorMessage = '';
    let loginDetails = {
      "username": this.f.username.value,
      "password": this.f.password.value
    };
    this.authservice.authenticate(loginDetails).subscribe(token => {
      this.loginErrorMessage = "";
      if (token != null && Boolean(token.status)) {
        this.router.navigate(["home"]);
        //avoid overlapping widgets 
        window.location.reload();
      }
      else {
        if (token.hasOwnProperty('errorMessage')) {
          this.loginErrorMessage = token.errorMessage;
        }
        else {
          this.loginErrorMessage = token.statusText == undefined
            ? "API is down." : token.statusText;
        }
      }
    }, error => {
      this.authservice.logOut();
    });
  }
}
